import React from "react";
import useDisplayCheck from "../useDisplayCheck";
import { Box } from "@mui/material";

interface JFCustomProps {
	field: {
		identifier: string;
		visible?: boolean;
		classes?: {
			wrapper?: string
		};
		children?: React.ReactNode;
	};
	customComponents: Record<string, React.ReactNode>;
}

const JFCustom: React.FC<JFCustomProps> = ({ field, customComponents }) => {
	const { identifier, children = <></>, classes={} } = field;
	const display = useDisplayCheck(field?.visible);

	return (
		<>
			{display ? (
				<Box className={`${classes.wrapper}`}>
					{customComponents[identifier] ? (
						<>{customComponents[identifier]}</>
					) : (
						<>{children}</>
					)}
				</Box>
			) : (
				<></>
			)}
		</>
	);
};

export default JFCustom;
